<template>
  <SettingsLayout>
    <nuxt />
  </SettingsLayout>
</template>

<script>
import SettingsLayout from '~/layouts/settings'

export default {
  middleware: [
    'isAuthorized',
    'allowNonMember',
    'hasBeenInducted',
    'initializer'
  ],

  components: {
    SettingsLayout
  }
}
</script>
